import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-check-circle-filled',
  imports: [],
  templateUrl: './check-circle-filled.html',
  styleUrl: './check-circle-filled.scss',
})
export class CheckCircleFilled {
  fill = input('#E1E2E6');
  width = input('1rem');
  height = input('1rem');
}
